export class Definition {
  private _left: string;
  private _right: string;
  public check: boolean;

  constructor(left?: string, right?: string, check?: boolean) {
    this._left = left != null && left != '' ? left.trim() : left;
    this._right = right != null && right != '' ? right.trim() : right;
    this.check = check === true ? true : false;
  }

  get left(): string {
    return this._left;
  }

  set left(value: string) {
    this._left = value != null && value != '' ? value.trim() : value;
  }

  get right(): string {
    return this._right;
  }

  set right(value: string) {
    this._right = value != null && value != '' ? value.trim() : value;
  }

  isEmpty(): boolean {
    const leftEmpty = this._left == null || this._left === '';
    const rightEmpty = this._right == null || this._right === '';
    return leftEmpty && rightEmpty;
  }
}

export class SimpleDefinition {
  private _left: string;

  constructor(left?: string) {
    this._left = left != null && left != '' ? left.trim() : left;
  }

  get left(): string {
    return this._left;
  }

  set left(value: string) {
    this._left = value != null && value != '' ? value.trim() : value;
  }

  isEmpty(): boolean {
    return this._left == null || this._left === '';
  }
}
